<app-navbar-style-two></app-navbar-style-two>
<app-partner></app-partner>

<!-- Start Page Title Area -->
<section class="subcategory-section">
    <div class="container">
        <!-- Section Header -->
        <div class="section-header" *ngFor="let Content of pageTitle;">
            <div class="section-badge">Our Products</div>
            <h2 class="section-title">{{Content.title}}</h2>
            <p class="section-description">Explore our wide range of fire protection products and solutions designed to keep your property safe.</p>
        </div>
    </div>
</section>
<!-- End Page Title Area -->
<!-- Start Gallery Area -->
<section class="product-gallery pt-100 pb-70">
    <div class="container">
        <div class="row g-4">
            <div class="col-lg-4 col-md-6 col-sm-6" *ngFor="let product of productItems;">
                <div class="product-card shadow-sm h-100">
                    <a [routerLink]="['/product', product.id]" class="product-link">
                        <div class="product-image-container">
                            <img [src]="product.product_image" alt="{{product.product_name}}" class="product-image img-fluid" (error)="$any($event.target).src='assets/img/placeholder-product.svg'">
                            <div class="product-overlay">
                                <button class="btn btn-sm btn-light quick-view">Quick View</button>
                            </div>
                        </div>
                        <div class="product-info p-3">
                            <h5 class="product-name mb-2">{{ product.product_name }}</h5>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- End Gallery Area -->
